"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TargetItem = _interopRequireDefault(require("./TargetItem.js"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _reactDnd = require("react-dnd");

var _uuid = _interopRequireDefault(require("uuid"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var target = {
  drop: function drop(props, monitor, component) {
    var item = monitor.getItem();
    props.onDrop(item.type, item.id, component.state.placeholderPosition);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var ElementTarget =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ElementTarget, _React$Component);

  function ElementTarget() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ElementTarget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ElementTarget)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      placeholderPosition: 0
    });

    _defineProperty(_assertThisInitialized(_this), "_getPlaceholder", function () {
      return _react.default.createElement("div", {
        key: "placeholder",
        className: _style.default.placeholder
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getElementField", function (type, id) {
      return (0, _find2.default)(_this.props.elementFields[type], function (item) {
        return item.id.value === id;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleAllElements", function (show) {
      _this.props.elements.forEach(function (element) {
        element.isExpanded.onChange(show);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_goToNextElement", function (currentElement) {
      if (!_this.props.moveOnTab) {
        return;
      }

      var index = (0, _findIndex2.default)(_this.props.elements, {
        id: currentElement.id
      });

      if (_this.props.elements[index + 1]) {
        // By changing the isExpanded we reload the whole block
        // and focus on the first element there
        _this.props.elements[index + 1].isExpanded.onChange((0, _uuid.default)());
      } else {
        _this.props.addElement(currentElement.type.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_getElements", function () {
      var elements = [];

      _this.props.elements.forEach(function (element, index) {
        var id = element.id.value;

        if (_this.props.isOver && id === _this.state.placeholderPosition) {
          elements.push(_this._getPlaceholder());
        }

        elements.push(_react.default.createElement(_TargetItem.default, {
          key: id,
          constant: _this.props.constant,
          index: index,
          element: element,
          elementTypes: _this.props.elementTypes,
          elementField: _this._getElementField(element.type.value, id),
          deleteElement: _this.props.deleteElement,
          renderElement: _this.props.renderElement,
          blockType: _this.props.blockType,
          canDrag: _this.props.elements.length > 1,
          movePlaceholderBefore: _this._movePlaceholderBefore,
          movePlaceholderAfter: _this._movePlaceholderAfter,
          toggleAllElements: _this._toggleAllElements,
          goToNextElement: _this._goToNextElement,
          extraProps: _this.props.extraProps
        }));
      });

      if (_this.props.isOver && _this.state.placeholderPosition === 0) {
        elements.push(_this._getPlaceholder());
      }

      if (elements.length === 0) {
        elements = _react.default.createElement("div", {
          className: _style.default.dragDropHint
        }, _this.props.dragHint);
      }

      return elements;
    });

    _defineProperty(_assertThisInitialized(_this), "_movePlaceholderBefore", function (id) {
      if (_this.state.placeholderPosition === id) {
        return;
      }

      _this.setState({
        placeholderPosition: id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_movePlaceholderAfter", function (id) {
      var elements = _this.props.elements;
      var index = (0, _findIndex2.default)(elements, function (element) {
        return element.id.value === id;
      });
      var next = elements[index + 1];
      var placeholderPosition = next ? next.id.value : 0;

      if (_this.state.placeholderPosition === placeholderPosition) {
        return;
      }

      _this.setState({
        placeholderPosition: placeholderPosition
      });
    });

    return _this;
  }

  _createClass(ElementTarget, [{
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      return connectDropTarget(_react.default.createElement("div", null, this._getElements()));
    }
  }]);

  return ElementTarget;
}(_react.default.Component);

_defineProperty(ElementTarget, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired,
  isOver: _propTypes.default.bool.isRequired,
  constant: _propTypes.default.string.isRequired,
  elements: _propTypes.default.array.isRequired,
  elementFields: _propTypes.default.object.isRequired,
  elementTypes: _propTypes.default.object.isRequired,
  deleteElement: _propTypes.default.func.isRequired,
  renderElement: _propTypes.default.func.isRequired,
  dragHint: _propTypes.default.string,
  blockType: _propTypes.default.string,
  onDrop: _propTypes.default.func.isRequired,
  addElement: _propTypes.default.func,
  moveOnTab: _propTypes.default.bool,
  extraProps: _propTypes.default.object
});

var _default = (0, _reactDnd.DropTarget)(function (props) {
  return props.constant;
}, target, collect)(ElementTarget);

exports.default = _default;